import React from "react";

const TreeIcon = ({ className = "" }) => {
  return (
    <svg
      aria-hidden="true"
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="11px"
      height="12px"
      viewBox="0 0 11 12"
      className={className}
    >
      <g id="v5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Discovery-v2--add-canopy"
          transform="translate(-1331.000000, -346.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path
            d="M1337.53081,357.375207 C1337.78626,357.375207 1337.95255,357.106233 1337.83825,356.877626 L1337.18749,355.837798 L1337.18749,354.625003 L1339.82276,354.625003 C1341.02309,354.625003 1341.99997,353.657789 1341.99997,352.468829 C1341.99997,351.700135 1341.59435,351.013266 1340.95068,350.630849 C1340.97957,350.505846 1341.00307,350.300255 1341.00309,350.171958 C1341.00309,348.913824 1339.88656,347.907061 1338.61705,348.025455 C1338.38652,347.079914 1337.52458,346.375023 1336.49999,346.375023 C1335.47539,346.375023 1334.61346,347.079914 1334.38313,348.025665 C1333.11363,347.907061 1331.99709,348.913824 1331.99709,350.172167 C1331.99709,350.326628 1332.01448,350.480039 1332.0495,350.631059 C1331.40562,351.013266 1331,351.700135 1331,352.468829 C1331,353.657789 1331.97689,354.625003 1333.17722,354.625003 L1335.81249,354.625003 L1335.81249,355.837798 L1335.16173,356.877626 C1335.04742,357.106233 1335.21372,357.375207 1335.46916,357.375207 L1337.53081,357.375207 Z M1339.82276,353.593756 L1333.17722,353.593756 C1332.54559,353.593756 1332.03125,353.089294 1332.03125,352.468829 C1332.03125,351.975781 1332.35823,351.546094 1332.84421,351.399984 L1333.43696,351.222109 L1333.15508,350.671237 C1333.07045,350.507105 1333.02813,350.3393 1333.02813,350.172167 C1333.02813,349.551703 1333.5418,349.046821 1334.17345,349.046821 C1334.33265,349.046821 1334.49099,349.081397 1334.64482,349.149291 L1335.45112,349.507223 L1335.35381,348.531407 C1335.35402,347.910732 1335.86813,347.40627 1336.49999,347.40627 C1337.13184,347.40627 1337.64596,347.910732 1337.64275,348.553101 L1337.54863,349.507223 L1338.35494,349.149291 C1339.11956,348.811563 1339.97164,349.395291 1339.97164,350.172167 C1339.97164,350.3393 1339.92932,350.507105 1339.84466,350.671237 L1339.56278,351.222109 L1340.15555,351.399984 C1340.64151,351.546094 1340.96852,351.975781 1340.96852,352.468829 C1340.96873,353.089294 1340.45438,353.593756 1339.82276,353.593756 Z"
            id="tree"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default TreeIcon;
